module.exports = __webpack_public_path__ + "static/domenico-loia-_zl4e_0S50w-unsplash-5dbd455219a986eb95a1ba285e72c45c.png";